<template>
  <div
    class="m-dropdown-content m-dropdown-content-right editor-dropdown-icons"
    id="MoleculeContentEditorDropDownIcons"
  >
    <section class="m-dropdown-section">
      <span
        v-if="selectedIcon.length"
        class="display-flex-column-center selected-icon"
      >
        <span>
          <img :src="`/img/map-icons/${selectedIcon}`">
        </span>
        <a
          href="#"
          class="text-link-hover-danger"
          @click.prevent="removeIcon"
        >
          <i class="far fa-trash-alt"></i>
        </a>
      </span>
      <ul>
        <li
          v-for="(icon, index) in icons"
          :key="index"
        >
          <a @click.stop="handleIcon(icon)">
            <img :src="`/img/map-icons/${icon}`">
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorDropDownIcons',

  props: {
    selectedIcon: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      icons: [
        '1-sonriendo1.png',
        '2-sonriendo2.png',
        '3-sonriendo3.png',
        '4-riendo1.png',
        '5-sonriendo4.png',
        '6-alegria1.png',
        '7-amigable.png',
        '8-angel.png',
        '9-sonriendo5.png',
        '10-sonriendo6.png',
        '11-guino.png',
        '12-enamorado.png',
        '13-beso1.png',
        '14-beso2.png',
        '15-lengua1.png',
        '16-lengua2.png',
        '17-sonriendo7.png',
        '18-lengua3.png',
        '19-sonriendo8.png',
        '20-riendo2.png',
        '21-curioso.png',
        '22-pardillo.png',
        '23-guay1.png',
        '24-pirata.png',
        '25-ninja.png',
        '26-sonriendo9.png',
        '27-guay2.png',
        '28-cansado1.png',
        '29-confundido1.png',
        '30-triste1.png',
        '31-confundido2.png',
        '32-angustiado1.png',
        '33-llorando1.png',
        '34-enfadado1.png',
        '35-enfadado2.png',
        '36-lesionado.png',
        '37-lengua3.png',
        '38-decepcionado.png',
        '39-cansado2.png',
        '40-mudo.png',
        '41-neutral.png',
        '42-conmocionado1.png',
        '43-asustado.png',
        '44-conmocionado2.png',
        '45-angustiado3.png',
        '46-conmocionado3.png',
        '47-muerto.png',
        '48-durmiendo.png',
        '49-secreto.png',
        '50-callado.png',
        '51-lengua4.png',
        '52-vomitivo.png',
        '53-vomitar.png',
        '54-enfermo.png',
        '55-codicioso.png',
        '56-monstruo.png',
        '57-bebe1.png',
        '58-payaso.png',
        '59-alien.png',
        '60-caca.png',
        '61-megusta.png',
        '62-nomegusta.png',
        '63-apretondemanos.png',
        '64-corazon1.png',
        '65-corazonroto.png',
        '66-corazonradiante.png',
        '67-corazones.png',
        '68-beso3.png',
        '69-boca.png',
        '70-lengua5.png',
        '71-oreja.png',
        '72-nariz.png',
        '73-ojos.png',
        '74-cerebro.png',
        '75-corazon2.png',
        '76-pulmones.png',
        '77-rinones.png',
        '78-estomago.png',
        '79-higado.png',
        '80-intestinos.png',
        '81-gas.png',
        '82-aplauso.png',
        '83-punetazo.png',
        '84-puno.png',
        '85-victoria.png',
        '86-perfecto.png',
        '87-senalaraladerecha.png',
        '88-senalaralaizquierda.png',
        '89-senalararriba.png',
        '90-senalarabajo.png',
        '91-levantareldedo.png',
        '92-mano.png',
        '93-spock.png',
        '94-adios.png',
        '95-fuerte.png',
        '96-manosarriba.png',
        '97-porfavor.png',
        '98-pintarselasunas.png',
        '99-flamenca.png',
        '100-familia.png',
        '101-padre.png',
        '102-madre.png',
        '103-matrimonio.png',
        '104-hijo.png',
        '105-hija.png',
        '106-bebe2.png',
        '107-abuelo1.png',
        '108-abuela1.png',
        '109-abuelo2.png',
        '110-abuela2.png',
        '111-chico1.png',
        '112-chico2.png',
        '113-chico3.png',
        '114-chico4.png',
        '115-chica1.png',
        '116-chica2.png',
        '117-chica3.png',
        '118-chica4.png',
        '119-doctor.png',
        '120-doctora.png',
        '121-enfermera.png',
        '122-jardinero.png',
        '123-obrero.png',
        '124-artista.png',
        '125-juez.png',
        '126-empresario.png',
        '127-cura.png',
        '128-espia.png',
        '129-guardaespaldas.png',
        '130-bombero.png',
        '131-policia.png',
        '132-capitan.png',
        '133-piloto1.png',
        '134-azafata.png',
        '135-teleoperadora.png',
        '136-teleoperador.png',
        '137-chef.png',
        '138-camarero.png',
        '139-futbolista.png',
        '140-piloto2.png',
        '141-jugadordebaloncesto.png',
        '142-ladron.png',
        '143-sombrerodecopa.png',
        '144-vestido.png',
        '145-maleta.png',
        '146-paraguas.png',
        '147-mochila.png',
        '148-birrete.png',
        '149-gafas.png',
        '150-lazo.png',
        '151-anillo.png',
        '152-zapato.png',
        '153-tacon.png',
        '154-chanclas.png',
        '155-huellas.png',
        '156-mono1.png',
        '157-mono2.png',
        '158-mono3.png',
        '159-mono4.png',
        '160-perro1.png',
        '161-gato1.png',
        '162-narizdecerdo.png',
        '163-cerdo1.png',
        '164-leon.png',
        '165-buho.png',
        '166-panda.png',
        '167-tigre1.png',
        '168-zorro.png',
        '169-raton.png',
        '170-unicornio.png',
        '171-pollito.png',
        '172-pajaro.png',
        '173-loro.png',
        '174-pez.png',
        '175-perro2.png',
        '176-gato2.png',
        '177-caballo.png',
        '178-cerdo2.png',
        '179-cabra.png',
        '180-vaca.png',
        '181-toro.png',
        '182-tigre2.png',
        '183-leopardo.png',
        '184-tortuga.png',
        '185-gallina.png',
        '186-pavo.png',
        '187-pato.png',
        '188-conejo.png',
        '189-rata.png',
        '190-oveja.png',
        '191-dromedario.png',
        '192-camello.png',
        '193-elefante.png',
        '194-murcielago.png',
        '195-ardilla.png',
        '196-paloma.png',
        '197-cocodrilo.png',
        '198-serpiente.png',
        '199-delfin.png',
        '200-tiburon.png',
        '201-ballena.png',
        '202-calamar.png',
        '203-pulpo.png',
        '204-mariposa.png',
        '205-oruga.png',
        '206-caracol.png',
        '207-grillo.png',
        '208-mariquita.png',
        '209-arana.png',
        '210-escorpion.png',
        '211-abeja.png',
        '212-arbol.png',
        '213-seta.png',
        '214-cactus.png',
        '215-flor.png',
        '216-otono.png',
        '217-invierno.png',
        '218-primavera.png',
        '219-verano.png',
        '220-nubes.png',
        '221-viento.png',
        '222-lluvia.png',
        '223-nublado.png',
        '224-arcoiris.png',
        '225-tormenta.png',
        '226-gota.png',
        '227-tornado.png',
        '228-termometro.png',
        '229-tierra.png',
        '230-luna.png',
        '231-fuego.png',
        '232-manzana.png',
        '233-pera.png',
        '234-platanos.png',
        '235-tomate.png',
        '236-zanahoria.png',
        '237-pimiento.png',
        '238-fresa.png',
        '239-sandia.png',
        '240-calabaza.png',
        '241-berenjena.png',
        '242-limon.png',
        '243-naranja.png',
        '244-albaricoque.png',
        '245-chili.png',
        '246-vino.png',
        '247-refresco.png',
        '248-cafe.png',
        '249-cubiertos.png',
        '250-tarta.png',
        '251-croissant.png',
        '252-queso.png',
        '253-carne.png',
        '254-huevofrito.png',
        '255-donut.png',
        '256-hamburguesa.png',
        '257-patatasfritas.png',
        '258-perritocaliente.png',
        '259-pizza.png',
        '260-taco.png',
        '261-helado.png',
        '262-futbol.png',
        '263-baloncesto.png',
        '264-bolos.png',
        '265-rugby.png',
        '266-correr.png',
        '267-estirar.png',
        '268-nadar.png',
        '269-diana.png',
        '270-trofeo.png',
        '271-oro.png',
        '272-plata.png',
        '273-bronce.png',
        '274-videojuegos1.png',
        '275-maquinadecoaser.png',
        '276-bucear.png',
        '277-tejer.png',
        '278-pintar.png',
        '279-videojuegos2.png',
        '280-ajedrez.png',
        '281-libro.png',
        '282-video.png',
        '283-claqueta.png',
        '284-musica.png',
        '285-karaoke.png',
        '286-teatro.png',
        '287-cine.png',
        '288-escritura.png',
        '289-guitarra.png',
        '290-puzzle.png',
        '291-coche.png',
        '292-taxi.png',
        '293-camion.png',
        '294-moto.png',
        '295-bicicleta.png',
        '296-avion.png',
        '297-cohete.png',
        '298-autobus.png',
        '299-tren.png',
        '300-metro.png',
        '301-globoaerostatico.png',
        '302-submarino.png',
        '303-barco.png',
        '304-brujula.png',
        '305-timon.png',
        '306-ancla.png',
        '307-ola.png',
        '308-faro.png',
        '309-playa.png',
        '310-montana.png',
        '311-volcan.png',
        '312-casa.png',
        '313-colegio.png',
        '314-hospital.png',
        '315-tienda.png',
        '316-banco.png',
        '317-castillo.png',
        '318-fabrica.png',
        '319-ciudad.png',
        '320-movil.png',
        '321-portatil.png',
        '322-microfono.png',
        '323-camara.png',
        '324-impresora.png',
        '325-televisor.png',
        '326-carpeta.png',
        '327-documento.png',
        '328-nota.png',
        '329-carta.png',
        '330-clip.png',
        '331-calculadora.png',
        '332-lapiz.png',
        '333-regla.png',
        '334-tijeras.png',
        '335-archivadores.png',
        '336-archivador.png',
        '337-reloj.png',
        '338-relojdearena.png',
        '339-calendario.png',
        '340-discodeoro.png',
        '341-candadocerrado.png',
        '342-candadoabierto.png',
        '343-llave.png',
        '344-papelera.png',
        '345-campana.png',
        '346-engranaje.png',
        '347-bombillaencendida.png',
        '348-bombillaapagada.png',
        '349-balanza.png',
        '350-billetes.png',
        '351-monedas.png',
        '352-carritodelacompra.png',
        '353-graficocircular.png',
        '354-crecimiento.png',
        '355-decrecimiento.png',
        '356-graficodebarras.png',
        '357-presentacion.png',
        '358-regalo.png',
        '359-aviondepapel.png',
        '360-caja.png',
        '361-prismaticos.png',
        '362-cama.png',
        '363-inodoro.png',
        '364-linterna.png',
        '365-vela.png',
        '366-ataud.png',
        '367-globo.png',
        '368-cuadro.png',
        '369-pincel.png',
        '370-peluqueria.png',
        '371-puerta.png',
        '372-confeti.png',
        '373-navajamultiusos.png',
        '374-pastilla.png',
        '375-barrera.png',
        '376-embudo.png',
        '377-chincheta.png',
        '378-herramientas.png',
        '379-pico.png',
        '380-agujero.png',
        '381-martillo.png',
        '382-espada.png',
        '383-escudo.png',
        '384-corona.png',
        '385-explosion.png',
        '386-medalla.png',
        '387-bomba.png',
        '388-diamante.png',
        '389-mapa.png',
        '390-estrella.png',
        '391-muro.png',
        '392-rayo.png',
        '393-meta.png',
        '394-banderaverde.png',
        '395-banderaamarilla.png',
        '396-banderaroja.png',
        '397-si.png',
        '398-no.png',
        '399-arriba.png',
        '400-abajo.png',
        '401-izquierda.png',
        '402-derecha.png',
        '403-diverger.png',
        '404-converger.png',
        '405-aviso.png',
        '406-peligro.png',
        '407-positivo.png',
        '408-negativo.png',
        '409-cero.png',
        '410-uno.png',
        '411-dos.png',
        '412-tres.png',
        '413-cuatro.png',
        '414-cinco.png',
        '415-seis.png',
        '416-siete.png',
        '417-ocho.png',
        '418-nueve.png',
        '419-interrogacion.png',
        '420-exclamacion.png',
        '421-ok.png',
        '422-sos.png',
        '423-retroceder.png',
        '424-play.png',
        '425-stop.png',
        '426-avanzar.png',
        '427-sinbateria.png',
        '428-bateriavacia.png',
        '429-bateriallena.png',
        '430-sinwifi.png',
        '431-pocacobertura.png',
        '432-muchacobertura.png',
        '433-circuloazul.png',
        '434-circulorojo.png',
        '435-circulonegro.png',
        '436-circuloblanco.png',
        '437-corazonnegro.png',
        '438-corazonazul.png',
        '439-corazonamarillo.png',
        '440-corazonvioleta.png',
        '441-corazonverde.png',
        '442-corazonrojo.png',
        '443-prohibido.png',
        '444-prohibidoamenores.png',
        '445-reciclable.png',
        '446-enobras.png',
        '447-firewall.png',
        '448-girarelmovil.png',
        '449-llamada.png',
        '450-arroba.png',
        '451-informacion.png',
        '452-youtube.png',
        '453-googledrive.png',
        '454-gmail.png',
        '455-chrome.png',
        '456-safari.png',
        '457-apple.png',
        '458-vidroop.png',
        '459-facebook.png',
        '460-skype.png',
        '461-spotify.png',
        '462-telegram.png',
        '463-vlc.png',
        '464-linkedin.png',
        '465-whatsapp.png',
        '466-twitter.png',
        '467-instagram.png',
        '468-netflix.png',
        '469-windows.png',
        '470-word.png',
        '471-excel.png',
        '472-powerpoint.png',
        '473-outlook.png',
        '474-acrobat.png',
        '475-photoshop.png',
        '476-pinterest.png',
        '477-paypal.png',
        '478-dropbox.png',
        '479-vimeo.png',
        '480-mcdonalds.png'
      ]
    }
  },

  methods: {
    handleIcon (icon) {
      this.$emit('handleIcon', icon)
    },

    removeIcon () {
      this.$emit('removeIcon')
    }
  }
}
</script>
